<template>
    <span v-if="text" class="character-count">
        {{ text }}
    </span>
</template>

<script>
import Vue from "vue";

export default {
  name: "character-count",
  props: {
    value: {
      type: String
    },
    max: {
      type: Number
    }
  },
  created: function () {
    Vue.$bundle("portal", this.bundle, (bundle) => {
      this.bundle = bundle;
    });
  },
  data: function () {
    return {
      bundle: {
        id_12243: "{0} / {1}"
      }
    };
  },
  computed: {
    text: function () {
      if (!this.value || !this.max) {
        return null;
      }
      return this.bundle.id_12243.replace("{0}", this.value.length).replace("{1}", this.max);
    }
  }
}
</script>

<style lang="less">
.character-count {
  float: right;
  margin: 0 0 0 1rem;
}
</style>